'use strict';

//  重写xhr open和send方法，监控页面上的ajax调用
var global = window;
var xhr = global.XMLHttpRequest;
var Event = require('./util/event');
var Logger = require('./util/logger');
var NOOP = function NOOP() {};

/**
 * 重写XMLHttpRequest
 */
var init = function init() {

    if (!xhr) return;

    if ('_owl' in xhr) return;

    xhr._owl = true;

    var protocol = global.location.protocol;

    if (protocol === 'file:') return;

    var _open = xhr.prototype.open;
    var _send = xhr.prototype.send;

    xhr.prototype.open = function (method, url) {
        this.url = url;
        this._startTime = +new Date();
        return _open.apply(this, arguments);
    };

    xhr.prototype.send = function () {
        var _this = this;

        var ADD_EVENT_LISTENER = 'addEventListener';
        var ON_READY_STATE_CHANGE = 'onreadystatechange';
        var _dispatchEvent = function _dispatchEvent(event) {
            if (event) {
                var duration = +new Date() - _this._startTime;
                event.duration = duration;

                //  如果是上报接口本身的xhr不再进行拦截
                if (/catfront.(dianping|51ping).com/.test(_this.url)) {
                    var response = void 0;
                    try {
                        if (_this.getAllResponseHeaders('content-type').indexOf('application/json') !== -1) {
                            response = event.currentTarget.response;
                            response = JSON.parse(response);
                        }
                    } catch (e) {
                        Logger.ignore(e);
                    }
                    if (event.currentTarget.status === 200) {
                        _this.success && _this.success(response);
                    } else {
                        _this.fail && _this.fail(response);
                    }
                } else {
                    Event.trigger('ajaxCall', event);
                }
            }
        };

        if (ADD_EVENT_LISTENER in this) {
            // xhr Level 2
            this[ADD_EVENT_LISTENER]('load', _dispatchEvent);
            this[ADD_EVENT_LISTENER]('error', _dispatchEvent);
            this[ADD_EVENT_LISTENER]('abort', _dispatchEvent);
        } else {
            var _originStateChange = this[ON_READY_STATE_CHANGE];
            this[ON_READY_STATE_CHANGE] = function (event) {
                if (this.readyState === 4) {
                    _dispatchEvent(event);
                }
                if (_originStateChange) {
                    _originStateChange.apply(this, arguments);
                }
            };
        }

        return _send.apply(this, arguments);
    };
};
init();

/**
 * 封装AJAX接口
 */
module.exports = function (opts) {
    if (!opts) return;

    var UA = window.navigator.userAgent;
    var browserName = window.navigator.appName;
    var isIE89 = browserName.indexOf('Microsoft Internet Explorer') !== -1 && (UA.indexOf('MSIE 8.0') !== -1 || UA.indexOf('MSIE 9.0') !== -1);
    var useXDomainRequest = isIE89 && window.XDomainRequest;
    var req = void 0;
    if (useXDomainRequest) {
        req = new XDomainRequest();
    } else {
        req = new XMLHttpRequest();
    }

    req.open(opts.type || 'GET', opts.url, true);
    req.success = opts.success || NOOP;
    req.fail = opts.fail || NOOP;
    if (opts.type === 'POST') {
        if (opts.header && !useXDomainRequest) {
            for (var key in opts.header) {
                if (opts.header.hasOwnProperty(key)) {
                    req.setRequestHeader(key, opts.header[key]);
                }
            }
        }
        req.send(opts.data);
    } else {
        req.send();
    }
    return req;
};


//////////////////
// WEBPACK FOOTER
// ./~/@dp/owl/lib/xhr.js
// module id = 54
// module chunks = 0